import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { NaverBizItemUpdateReq, NaverConnectReq, NaverDisconnectReq, NaverLoginReq, NaverLoginRes } from "../api.type";
import * as api from "../api";

export const useNaverLoginMutation = (rootStore: any): UseMutationResult<API.DefaultResponse<NaverLoginRes>, Error, NaverLoginReq> => {
	return useMutation({
		mutationFn: (payload: NaverLoginReq) => api.postNaverLogin(rootStore, payload),
	});
}

export const useNaverDisconnectMutation = (rootStore: any): UseMutationResult<API.DefaultResponse<string>, Error, NaverDisconnectReq> => {
	return useMutation({
		mutationFn: (payload: NaverDisconnectReq) => api.postNaverDisconnect(rootStore, payload),
	});
}

export const useNaverConnectMutation = (rootStore: any): UseMutationResult<API.DefaultResponse<string>, Error, NaverConnectReq> => {
	return useMutation({
		mutationFn: (payload: NaverConnectReq) => api.postNaverConnect(rootStore, payload),
	});
}

export const useNaverBizItemUpdateMutation = (rootStore: any): UseMutationResult<API.DefaultResponse<string>, Error, NaverBizItemUpdateReq> => {
	return useMutation({
		mutationFn: (payload: NaverBizItemUpdateReq) => api.patchNaverBizItem(rootStore, payload),
	});
}